// ** Reducers Imports
import bank from './pagesSlices/emolume_bank'

import error from "./errors/handleErrorsAndPayloads";
import { combineReducers } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
  error,
  bank
});
// const rootReducer = {
//   cms,
//   error,
// };

export default rootReducer;
